<div class="lobby__content">
    <div class="lobby__container--main" #mainContainer
         [class.chat-opened]="chatOpened">
        <statistics-panel class="lobby__statistics-panel"
                          (onTabChanged)="onStatisticsTabChanged($event)"></statistics-panel>
        <div class="lobby__container--game-panel">
            <div class="lobby__round-history">
                <history [itemTemplate]="payoutItemTemplate" [data]="historyDataArray" [numberOfRows]="2"
                         [trackBy]="historyTrackBy"></history>
            </div>
            <game class="lobby__game" [layoutChange]="chatOpened"></game>
            <div class="lobby__container--bet">
                <bet-panel class="lobby__bet-panel first" bet-panel-wallet-animation
                           [balanceAvailable]="balanceAvailable"
                           [class.no-second-panel]="!multiBetPanelEnabled"
                           [disabled]="stateFetchInProgress"
                           [stateName]="betButtonStates[0].stateName"
                           [buttonModifier]="betButtonStates[0].buttonModifier"
                           [textKey]="betButtonStates[0].textKey"
                           [showAmountInText]="betButtonStates[0].showAmountInText"
                           [actionInProgress]="betButtonStates[0].actionInProgress"
                           [accumulatedAmount]="betButtonStates[0].accumulatedAmount"
                           [roundId]="betButtonStates[0].roundId"
                           [multiplier]="betButtonStates[0].multiplier"
                           [autoplayRoundCount]="betButtonStates[0].autoplayRoundCount"
                           [firstHalfCashedOut]="betButtonStates[0].firstHalfCashedOut"
                           [betIndex]="0"
                           [multiPanelButtonDisabled]="multiBetPanelEnabled"
                           [predefinedBetOptions]="betPanelData.predefinedBetOptions"
                           [betStepperConfig]="betPanelData.betStepperConfig"
                           [autoplayConfig]="betPanelData.autoplayConfig"
                           [multiplierConfig]="betPanelData.multiplierStepperConfig"
                           (onAutoPlayOptionsClicked)="openAutoplayOptionsPopup($event)"
                           (onAutoplayStart)="startAutoplay($event)"
                           (removeAutoplay)="removeAutoplay(0)"
                           (onSendBet)="sendBet($event)"
                           (onCashOut)="cashOut($event)"
                           (onCancelBet)="cancelBet($event)"
                           (multiPanelButtonClicked)="showSecondBetPanel()"></bet-panel>
                <bet-panel class="lobby__bet-panel second" bet-panel-wallet-animation
                           [balanceAvailable]="balanceAvailable"
                           [class.active]="multiBetPanelEnabled"
                           [disabled]="stateFetchInProgress"
                           [stateName]="betButtonStates[1].stateName"
                           [buttonModifier]="betButtonStates[1].buttonModifier"
                           [textKey]="betButtonStates[1].textKey"
                           [showAmountInText]="betButtonStates[1].showAmountInText"
                           [actionInProgress]="betButtonStates[1].actionInProgress"
                           [accumulatedAmount]="betButtonStates[1].accumulatedAmount"
                           [roundId]="betButtonStates[1].roundId"
                           [multiplier]="betButtonStates[1].multiplier"
                           [autoplayRoundCount]="betButtonStates[1].autoplayRoundCount"
                           [firstHalfCashedOut]="betButtonStates[1].firstHalfCashedOut"
                           [betIndex]="1"
                           [predefinedBetOptions]="betPanelData.predefinedBetOptions"
                           [betStepperConfig]="betPanelData.betStepperConfig"
                           [autoplayConfig]="betPanelData.autoplayConfig"
                           [multiplierConfig]="betPanelData.multiplierStepperConfig"
                           (onAutoPlayOptionsClicked)="openAutoplayOptionsPopup($event)"
                           (onAutoplayStart)="startAutoplay($event)"
                           (removeAutoplay)="removeAutoplay(1)"
                           (onSendBet)="sendBet($event)"
                           (onCashOut)="cashOut($event)"
                           (onCancelBet)="cancelBet($event)"
                           (multiPanelButtonClicked)="hideSecondBetPanel()"></bet-panel>
            </div>
        </div>
    </div>
<!--    <chat #chatEl class="lobby__chat"></chat>-->
</div>
<app-footer class="lobby__footer"></app-footer>

<ng-template #payoutItemTemplate let-data>
    <div class="lobby__wrapper--payout-item">
        <payout-item class="lobby__payout-item" [coefficient]="data"></payout-item>
    </div>
</ng-template>
